{
  "version": 1,
  "asset_id": "10d69194-17b5-4897-aee6-28e82506b256",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/10d69194-17b5-4897-aee6-28e82506b256/sleeve-fitzer-2.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/10d69194-17b5-4897-aee6-28e82506b256/sleeve-fitzer-2.png",
  "original_filename": "sleeve-fitzer-2.png",
  "size": 417599,
  "content_type": "image/png",
  "created_at": "2026-07-14T23:02:49Z"
}
